import { render, staticRenderFns } from "./uploader.vue?vue&type=template&id=127db307"
import script from "./uploader.vue?vue&type=script&lang=ts"
export * from "./uploader.vue?vue&type=script&lang=ts"
import style0 from "./uploader.vue?vue&type=style&index=0&id=127db307&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports